module.exports = __webpack_public_path__ + "img/google-play.5ebd396d.svg";